import React from 'react';
import classnames from 'classnames';

import { Accordion } from 'components';

import SupplierThumbnail from 'src/features/OrdersView/components/OrderSummary/components/SupplierThumbnail';
import { getFormattedAmount, getOrderRealizationSum, handleNumeralWords } from 'src/utils/helpers';

import style from './OrderSuppliersTable.module.scss';

const OrderSummary = ({ order }) => {
  const { suppliers = [], total_sum, order_approval } = order || {};

  const title = (
    <h2 className={style.tableTitle}>
      Podsumowanie
      <p className={style.suppliersQty}>
        ({suppliers.length} {handleNumeralWords(['dostawca', 'dostawców', 'dostawców'], suppliers.length)})
      </p>
    </h2>
  );

  return (
    <div className={style.accordionWrapper}>
      <Accordion title={title}>
        <div className={style.tableWrapper}>
          <div className={style.table}>
            <div className={classnames(style.wrapper, style.header)}>
              <p className={classnames(style.text, style.sum)}>Dostawca</p>
              <p className={classnames(style.amount, style.sum)}>Wartość</p>
              <p className={classnames(style.amount, style.sum)}>Produkty</p>
              <p className={classnames(style.amount, style.sum)}>W realizacji</p>
              <p className={classnames(style.text, style.sum)}>Faktura</p>
              <p className={classnames(style.amount, style.sum, style.margin)}>Status</p>
            </div>
            {suppliers.map((supplier) => (
              <SupplierThumbnail
                key={supplier.id}
                supplier={supplier}
                orderApproval={order_approval}
              />
            ))}
            <div className={classnames(style.wrapper, style.bottom)}>
              <p className={classnames(style.amount, style.sum)}>Suma:</p>
              <p className={classnames(style.amount, style.sum)}>{getFormattedAmount(total_sum)}</p>
              <p className={classnames(style.amount, style.sum)}>{getOrderRealizationSum(suppliers).allProductsSum}</p>
              <p className={classnames(style.amount, style.sum)}>{getOrderRealizationSum(suppliers).realizationSum}</p>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default OrderSummary;
